const IMA_SSAI_ERROR_BASE = 0x1000;

export const ImaSsaiErrorCodes = Object.freeze({
  /**
   * Indicates that ad playback failed and the underlying reason can be
   * found in the [Error] instance internal error's code.
   */
  AD_PLAYBACK_FAILURE: IMA_SSAI_ERROR_BASE + 0x01,
});
